import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({
      id: 'form.drivers.header.title',
    }),
  }))

  return api
}
